import ChangeCamera from "./ChangeCamera";
import ChangeMonitoringMode from "./ChangeMonitoringMode";
import DeleteActivityLogEvent from "./DeleteActivityLogEvent";
import GetSignedUrl from "./GetSignedUrl";
import SetLowLightMode from "./SetLowLightMode";
import Ping from "./Ping";
import PlayCommand from "./PlayCommand";
import PlayLullaby from "./PlayLullaby";
import RefreshActivityLog from "./RefreshActivityLog";
import SetLullabyPlayerTimer from "./SetLullabyPlayerTimer";
import StartActivityLog from "./StartActivityLog";
import StartListening from "./StartListening";
import StartMonitoring from "./StartMonitoring";
import StopMonitoringFromBaby from "./StopMonitoringFromBaby";
import StartVideoReceiving from "./StartVideoReceiving";
import StopActivityLog from "./StopActivityLog";
import StopListening from "./StopListening";
import StopLullaby from "./StopLullaby";
import StopLullabyAfterMonitoring from "./StopLullabyAfterMonitoring";
import StopMonitoring from "./StopMonitoring";
import StopVideoReceiving from "./StopVideoReceiving";
import StartVideoBroadcasting from "./StartVideoBroadcasting";
import StartVideoRecording from "./StartVideoRecording";
import StopVideoBroadcasting from "./StopVideoBroadcasting";
import StopVideoRecording from "./StopVideoRecording";
import SyncFromPS from "./SyncFromPS";
import TakeVideoSnapshot from "./TakeVideoSnapshot";

export { default as RPCRequest } from "./RPCRequest";

export const RPCRequests = {
  ChangeCamera,
  ChangeMonitoringMode,
  DeleteActivityLogEvent,
  GetSignedUrl,
  SetLowLightMode,
  Ping,
  PlayCommand,
  PlayLullaby,
  RefreshActivityLog,
  SetLullabyPlayerTimer,
  StartActivityLog,
  StartListening,
  StartMonitoring,
  StartVideoReceiving,
  StopActivityLog,
  StopListening,
  StopLullaby,
  StopLullabyAfterMonitoring,
  StopMonitoring,
  StopMonitoringFromBaby,
  StopVideoReceiving,
  StartVideoBroadcasting,
  StartVideoRecording,
  StopVideoBroadcasting,
  StopVideoRecording,
  SyncFromPS,
  TakeVideoSnapshot
};
